// var paywall = require("./lib/paywall");
// setTimeout(() => paywall(12345678), 5000);

require("component-responsive-frame/child");

var $ = require("./lib/qsa");
var m = require("./lib/dom");
var closest = require("./lib/closest");
var dot = require("./lib/dot");
var policyTemplate = dot.compile(require("./_policy.html"));
var ynTemplate = dot.compile(require("./_yesno.html"));

var container = $.one(".quiz-container");
var submitButton = $.one(".submit");
var animate = require("./lib/animateScroll");

var resultsBioHarrell = $.one(".bio-intro.harrell");
var resultsBioGonzalez = $.one(".bio-intro.gonzalez");
var tiedBio = $.one(".bio-tie");
var harrellBio = $.one(".harrell-bio");
var gonzalezBio = $.one(".gonzalez-bio");
var harrellName = $.one(".name-harrell");
var gonzalezName = $.one(".name-gonzalez");

var policies = window.policies;

var html = "";
policies.forEach(function(policy, index) {
  if (policy.yesno && policy.yesno.trim()) {
    html += ynTemplate({ policy, index });
  } else {
    var candidates = Math.random() > .5 ? ["harrell", "gonzalez"] : ["gonzalez", "harrell"];
    html += policyTemplate({ policy, index, candidates });
  }
});
container.innerHTML = html;

var results = $.one(".results-container");

var getScore = function() {
  var checked = $("input:checked", container);
  var values = checked.map(el => el.value);
  var counts = { harrell: 0, gonzalez: 0 };
  values.forEach(v => counts[v]++);
  counts.total = values.length;
  return counts;
};


var onChange = function(e) {
  if (e) {
    var item = closest(e.target, ".policy");
    item.classList.add("chosen");
  }
  var counts = getScore();
  // console.log(counts);
  results.innerHTML = `

    <div class="info">
      <div class="candidates"><span class="matchesTitle">Your matches:</span> González <span class="gonzalez number">${counts.gonzalez}</span>, Harrell <span class="harrell number">${counts.harrell}</span></div>
      <div class="counter">${counts.total}/${policies.length}</div>
    </div>
    `;
};

var onSubmit = function() {
  var score = getScore();

  // resets hidden classes
  resultsBioHarrell.classList.add("hidden");
  resultsBioGonzalez.classList.add("hidden");
  tiedBio.classList.add("hidden");
  harrellBio.classList.add("hidden");
  gonzalezBio.classList.add("hidden");
  harrellName.classList.remove("hidden");
  gonzalezName.classList.remove("hidden");

  // removes hidden classes from results
  if (score.harrell > score.gonzalez) {
    resultsBioHarrell.classList.remove("hidden");
    harrellBio.classList.remove("hidden");
    harrellName.classList.add("hidden");
  } else if (score.gonzalez > score.harrell) {
    resultsBioGonzalez.classList.remove("hidden");
    gonzalezBio.classList.remove("hidden");
    gonzalezName.classList.add("hidden");
  } else { // a tie
    tiedBio.classList.remove("hidden");
    harrellBio.classList.remove("hidden");
    gonzalezBio.classList.remove("hidden");
    harrellName.classList.remove("hidden");
    gonzalezName.classList.remove("hidden");
  }
}

$(".button").forEach(el => el.addEventListener("click", function(e) {
  e.preventDefault();
  animate(".submit", 1000);
}));

container.addEventListener("keydown", function(e) {
  if (e.keyCode == 13 && e.target.tagName == "LABEL") {
    var id = e.target.getAttribute("for");
    var input = $.one("#" + id);
    input.checked = true;
    var changeEvent = new Event("change", { bubbles: true });
    input.dispatchEvent(changeEvent);
    // onChange({ target: input })
  }
});

container.addEventListener("change", onChange);
submitButton.addEventListener("click", onSubmit);
onChange();